import {
  CognitoUserPool,
} from 'amazon-cognito-identity-js'
import { CognitoAuth } from 'amazon-cognito-auth-js'
import { connect } from 'react-redux'
import jwtDecode from 'jwt-decode'
import PropTypes from 'prop-types'
import React from 'react'
import qs from 'qs'
import settings from 'settings'
import {
  withRouter,
} from 'react-router-dom'

// Redux
import { initialize, login } from 'app/state/modules/auth'
import {
  getInviteToken,
  onboardUser,
} from 'app/state/modules/hacker'

// Utils
import {
  getAnonymousId,
  getEmailFromJWT,
  getUsernameFromJWT,
} from 'app/views/utils/auth'
import analytics from 'app/views/utils/analytics'

const propTypes = {
  location: PropTypes.shape({
    state: PropTypes.object, // withRouter
  }).isRequired,
  onLogin: PropTypes.func.isRequired, // mapDispatchToProps
  onboardUser: PropTypes.func.isRequired,
  inviteToken: PropTypes.string,
}

const defaultProps = {
  inviteToken: '',
}

class Auth extends React.Component {
  componentDidMount() {
    analytics.page('page-auth')

    let auth = null
    if (this.props.match.params.client_id === '1p6bb22tops0hjelbk500j5son') {
      localStorage.setItem('hackedu.cognito.clientId', '1p6bb22tops0hjelbk500j5son')
      auth = new CognitoAuth(settings.cognito.authDataHackEDU)
    } else if (this.props.match.params.client_id === '46m8aq1d3s534d9vuqv8hks801') {
      localStorage.setItem('hackedu.cognito.clientId', '46m8aq1d3s534d9vuqv8hks801')
      auth = new CognitoAuth(settings.cognito.authDataAllegiant)
    } else {
      localStorage.setItem('hackedu.cognito.clientId', 'bg6jqljbdakuts5tu3jqhuph0')
      auth = new CognitoAuth(settings.cognito.authData)
    }
    auth.userhandler = {
      onSuccess: (result) => {
        const decodedAuth = jwtDecode(result.idToken.jwtToken)

        const email = getEmailFromJWT(result.idToken.jwtToken)
        window.analytics.identify(getUsernameFromJWT(result.idToken.jwtToken), {
          email,
          anonymousId: getAnonymousId(),
        })

        if (this.props.inviteToken && this.props.inviteToken.length > 0) {
          this.props.onboardUser(result.idToken.jwtToken, this.props.inviteToken, null)
            .then(() => {
              this.refreshSession(result.refreshToken)
            })
        } else if ('identities' in decodedAuth) {
          const { providerName } = decodedAuth.identities[0]
          this.props.onboardUser(result.idToken.jwtToken, null, providerName)
            .then(() => {
              this.refreshSession(result.refreshToken)
            })
        } else {
          this.props.onLogin(
            getUsernameFromJWT(result.idToken.jwtToken),
            getEmailFromJWT(result.idToken.jwtToken),
            result.accessToken.jwtToken,
            result.idToken.jwtToken
          )
          this.props.onInitialize(true, null)
          const redirectTo = localStorage.getItem('hackedu.redirect.onLogin')
          if (redirectTo) {
            localStorage.removeItem('hackedu.redirect.onLogin')
            this.props.history.push(redirectTo)
          } else {
            this.props.history.push('/')
          }
        }
      },
      onFailure: (err) => {
        console.error('Error!!', err)
        this.props.history.push('/')
      },
    }
    auth.useCodeGrantFlow()
    auth.parseCognitoWebResponse(window.location.href)
  }

  refreshSession(refreshToken) {
    const clientId = localStorage.getItem('hackedu.cognito.clientId')
    let poolData = null
    if (clientId === '1p6bb22tops0hjelbk500j5son') {
      poolData = {
        UserPoolId: settings.cognito.authDataHackEDU.UserPoolId,
        ClientId: settings.cognito.authDataHackEDU.ClientId,
      }
    } else if (clientId === '46m8aq1d3s534d9vuqv8hks801') {
      poolData = {
        UserPoolId: settings.cognito.authDataAllegiant.UserPoolId,
        ClientId: settings.cognito.authDataAllegiant.ClientId,
      }
    } else {
      poolData = {
        UserPoolId: settings.cognito.authData.UserPoolId,
        ClientId: settings.cognito.authData.ClientId,
      }
    }

    const userPool = new CognitoUserPool(poolData)
    const user = userPool.getCurrentUser()

    user.refreshSession(refreshToken, (err, session) => {
      if (err) {
        console.error('error with refresh session: ', err)
      } else {
        this.props.onLogin(
          getUsernameFromJWT(session.idToken.jwtToken),
          getEmailFromJWT(session.idToken.jwtToken),
          session.accessToken.jwtToken,
          session.idToken.jwtToken
        )
        this.props.onInitialize(true, null)
        const redirectTo = localStorage.getItem('hackedu.redirect.onLogin')
        if (redirectTo) {
          localStorage.removeItem('hackedu.redirect.onLogin')
          this.props.history.push(redirectTo)
        } else {
          this.props.history.push('/')
        }
      }
    })
  }

  render() {
    const {
      location: {
        search,
      },
    } = this.props
    const queryString = search.substr(1)
    const queryParams = qs.parse(queryString)

    return (
      <div className="uk-container">
        <div className="uk-section">
          <div className="uk-container">
            <div className="uk-text-center">
              {
                queryParams.error
                  ? (<h1>{queryParams.error_description}</h1>)
                  : (<div data-uk-spinner="" />)
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}

Auth.propTypes = propTypes
Auth.defaultProps = defaultProps

const mapStateToProps = () => ({
  inviteToken: getInviteToken(),
})

const mapDispatchToProps = dispatch => ({
  onInitialize: (loggedIn, unauthenticatedId) => {
    dispatch(initialize(loggedIn, unauthenticatedId))
  },
  onLogin: (username, email, accessToken, idToken) => {
    dispatch(login(username, email, accessToken, idToken))
  },
  onboardUser: (idToken, teamToken, teamId) => dispatch(onboardUser(idToken, teamToken, teamId)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Auth))
